// extracted by mini-css-extract-plugin
export var card = "ContactSales-module--card--LVqS0";
export var contactIcons = "ContactSales-module--contactIcons--MbOCH";
export var divider = "ContactSales-module--divider--XPOAh";
export var personCard = "ContactSales-module--personCard--ACUTc";
export var section = "ContactSales-module--section--r+DfL";